<template>
  <section>
    <!-- start of appbar -->
    <v-app-bar
      flat
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="primary"
      dark
    >
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"/> -->
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Stalis MIS</span>
      </v-toolbar-title>
      <v-spacer />
      <v-btn text color="white" @click="logout">Logout</v-btn>
    </v-app-bar>
    <!-- end of appbar -->
  </section>
</template>

<script>
export default {
  data: () => ({
    drawer: true,
  }),
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
  },
};
</script>

